module.exports = __webpack_public_path__ + "static/amazon-vs-ebay-ec58584cdca5acacc24845ec472e6f71.png";